export enum BankTransactionCategory {
	BANK = 'bank',
	TRANSFER = 'transfer',
	VEHICLE = 'vehicle',
	SHOP = 'shop',
	JOB = 'job',
	DEPOSIT = 'deposit',
	WITHDRAW = 'withdraw',
}

export enum BankOperationType {
	DEPOSIT = 'deposit',
	WITHDRAW = 'withdraw',
	TRANSFER = 'transfer',
	TAX = 'tax',
}
